import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BadgeComponent, NotificationBadgeComponent } from '@sb/ui/badge';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sidebar-header',
  imports: [BadgeComponent, NotificationBadgeComponent],
  template: `
    <div class="flex h-10 items-center justify-between bg-surface-page px-3 font-bold text-default">
      <span>
        {{ title() }}
      </span>
      @if (indicator() && indicator() > 0) {
        <sb-notification-badge [count]="indicator()" [size]="'small'" [truncate]="false" />
      }
      @if (beta()) {
        <sb-badge [color]="'brandInverted'">BETA</sb-badge>
      }
    </div>
  `,
})
export class SidebarHeaderComponent {
  title = input.required<string>();
  indicator = input<number>();
  beta = input<boolean>(false);
}
